import { useQuery } from "react-query";
import { getOfficeHierarchyDistricts } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeHierarchyDistricts = () => {
  return useQuery("GetOfficeHierarchyDistricts", getOfficeHierarchyDistricts, {
    refetchOnWindowFocus: false,
  });
};
